const BASE = '/api';

async function request(path, { method = 'GET', body, token } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  let data = null;
  try {
    data = await res.json();
  } catch {
    /* non-JSON body — fall through to the error below */
  }

  if (!res.ok) {
    const err = new Error(data?.error || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  snapshot: (token) => request('/snapshot', { token }),

  // Employee endpoints
  clockOut: (payload) => request('/shift', { method: 'POST', body: payload }),
  deleteShift: (id, token) => request(`/shift/${id}`, { method: 'DELETE', token }),
  submitAudit: (payload) => request('/audit', { method: 'POST', body: payload }),
  deleteAudit: (id, token) => request(`/audit/${id}`, { method: 'DELETE', token }),

  // Manager — items
  restock: (id, token) => request(`/items/${id}/restock`, { method: 'POST', token }),
  addItem: (payload, token) => request('/items', { method: 'POST', body: payload, token }),
  updateItem: (id, payload, token) =>
    request(`/items/${id}`, { method: 'PATCH', body: payload, token }),
  deleteItem: (id, token) => request(`/items/${id}`, { method: 'DELETE', token }),

  // Manager — skyads
  addSkyad: (payload, token) => request('/skyads', { method: 'POST', body: payload, token }),
  updateSkyad: (id, payload, token) =>
    request(`/skyads/${id}`, { method: 'PATCH', body: payload, token }),
  deleteSkyad: (id, token) => request(`/skyads/${id}`, { method: 'DELETE', token }),

  // Manager — lifeinvader ads
  addAd: (payload, token) => request('/ads', { method: 'POST', body: payload, token }),
  deleteAd: (id, token) => request(`/ads/${id}`, { method: 'DELETE', token }),

  // Manager — auth
  verifyManager: (pin) => request('/manager/verify', { method: 'POST', body: { pin } }),
  logoutManager: (token) => request('/manager/logout', { method: 'POST', token }),
};